import { sleep } from './sleep';

export const waitAtLeast = async <T>(timeInMs: number, callback: () => T): Promise<T> => {
  const [callbackResult] = await Promise.all([callback(), sleep(timeInMs)]);

  return callbackResult;
};
